module.exports = {
  apiHost: "https://api.skyridge.sensoreal.com.au",
  assetsHost: "https://assets.skyridge.sensoreal.com.au",
  contact: {
    address: "167 Hinkler Drive, Worongary 4213",
    email: "info@skyridgeliving.com.au",
    phone: "",
    website: "https://skyridgeliving.com.au",
  },
  formTemplate: "skyridge",
  header: {
    logo: "https://assets.skyridge.sensoreal.com.au/misc/skyridge-logo.png",
    text: {
      en: "Your SkyRidge Selections",
      ar: "اختياراتك من SkyRidge",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "",
    facebook: "https://www.facebook.com/SkyRidgeLiving/",
    linkedin: "",
    privacy: "https://skyridgeliving.com.au/privacy",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#111f25",
    textColor: "#fff",
  },
};
